import { ADD_USER_STATE} from "../../enums/AuthType";

export const userSuccessRegisterAction = (user) =>{
    return {
        type:ADD_USER_STATE,
        payload:user,
    };
};
// export
